import axios from 'axios'

const usuarios = {
    state: () => ({
        usuarios: [],
        usu: {},
        usr: null
    }),

    getters: {
        obtenerUsuarios(state) {
            return state.usuarios
        },
       
        obtenerUsu(state) {
            return state.usu
        },

        obtenerUsuarioExperto: (state) => (identificacion) => {
            return state.usuariosws.find(usuariows => usuariows.identificacion == identificacion)
        },
    },

    mutations: {
        enviarUsuarios(state, usuarios) {
            state.usuarios = usuarios
        },

        enviarUsu(state, usuario) {
            state.usu = usuario
        },

        importarUsuarios(state, usr){
            state.usr = usr
        },

        enviarUsuariosWs(state, usuariosws){
            state.usuariosws = usuariosws
        },
    },

    actions: {
        registrarUsuario(context, usuario) {
            return new Promise((resolve, reject) => {
                axios.post("api/usuarios", usuario)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        gestionarUsuarios(context) {
            axios.get("api/usuarios")
            .then((response) => {
                const usuarios = []
                response.data.results.forEach((response, indice) => {
                    usuarios.push({
                        indice:                 (indice+1),
                        id:                     response.id_usuario,
                        centro_formacion_id:    response.centro_formacion.id_centro_formacion,
                        centro_formacion:       response.centro_formacion.centro_formacion,
                        regional_id:            response.centro_formacion.regional_id,
                        identificacion:         response.identificacion,
                        nombres:                response.nombres,
                        apellidos:              response.apellidos,
                        telefono:               response.telefono,
                        correo:                 response.correo
                    })
                });
               
                context.commit("enviarUsuarios", usuarios)
            })
            .catch(() => {})
        },

        detallesUsuario(context, id) {
            axios.get("api/usuarios/"+id)
            .then((response) => {
                const perfiles = response.data.results.perfiles.map((perfil) => {
                    return perfil.perfil
                })

                const usuario = {
                    id:                     response.data.results.id_usuario,
                    regional_id:            response.data.results.centro_formacion.regional.id_regional, 
                    regional:               response.data.results.centro_formacion.regional.regional, 
                    centro_formacion_id:    response.data.results.centro_formacion.id_centro_formacion,
                    centro_formacion:       response.data.results.centro_formacion.centro_formacion,
                    identificacion:         response.data.results.identificacion,
                    nombres:                response.data.results.nombres,
                    apellidos:              response.data.results.apellidos,
                    telefono:               response.data.results.telefono,
                    correo:                 response.data.results.correo,  
                    perfiles:               perfiles.join(', '),   
                }
                
                context.commit("enviarUsu", usuario)
            })
            .catch(() => {})
        },

        editarUsuario(context, usuario) {
            return new Promise((resolve, reject) => {
                axios.get("api/usuarios/"+usuario+"/editar")
                .then((response) => {
                    resolve(response.data.results)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        actualizarUsuario(context, usuario) {
            return new Promise((resolve, reject) => {
                axios.put('api/usuarios/'+usuario.id, usuario)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        actualizarPerfilUsuario(context, usuario) {
            return new Promise((resolve, reject) => {
                axios.put('api/perfilUsuario/'+usuario.id, usuario)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        importarUsuarios(context, usuarios) {
            const formData = new FormData();
            formData.append('usuario', usuarios);
            return new Promise((resolve, reject) => {
                axios.post("api/importarUsuarios", formData, { headers: {'Content-Type': 'multipart/form-data'} })
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },

        descargarPlantilla(context, usuario) {
            return new Promise((resolve, reject) => {
               axios.post("api/plantillaUsuarios", usuario, { responseType: 'blob' })
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        }    
        
    }
}

export default usuarios